import { create, StateCreator } from 'zustand'
import { devtools, persist, subscribeWithSelector } from 'zustand/middleware'

interface DevSettingsState {
    isImpersonateOn: boolean
}

interface DevSettingsActions {
    setImpersonateOn: (isImpersonateOn: boolean) => void
}
export interface IDevSettingsSlice
    extends DevSettingsState,
        DevSettingsActions {}
export const createDevSettings: StateCreator<
    DevStore,
    [],
    [],
    IDevSettingsSlice
> = (set, get) => ({
    isImpersonateOn: false,

    setImpersonateOn: (isImpersonateOn: boolean) => {
        set({ isImpersonateOn: isImpersonateOn })
    },
})

export interface DevStore extends IDevSettingsSlice {}

export const useDevStore = create<DevStore>()(
    subscribeWithSelector(
        devtools(
            persist(
                (...a) => ({
                    ...createDevSettings(...a),
                }),
                {
                    name: 'dev-store',
                }
            )
        )
    )
)

// alias for convenience
export const ds = useDevStore.getState
